module.exports = "DATABASE_URL=\"mysql://travolta:travolta@127.0.0.1:3306/travolta?charset=utf8mb4&serverVersion=5.7\""


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/pages/code/env-db.txt
// module id = 644
// module chunks = 279750246330496